import { Group, Loader, Switch, Text } from "@mantine/core";

const AsyncToggle = ({
  value,
  onChange,
  loading,
  onLabel = "ON",
  offLabel = "OFF",
  label = "Async Toggle"
}) => {
  return (
    <Switch
      label={
        <Group>
          <Text size="xs">{label}</Text>
          {loading && <Loader size="xs" />}
        </Group>
      }
      onLabel={onLabel}
      offLabel={offLabel}
      checked={value}
      onChange={onChange}
    />
  );
};

export default AsyncToggle;
